import { Auth } from "aws-amplify";

export const login = (email, password) => {
  return new Promise(async (resolve, reject) => {
    try {
      const user = await Auth.signIn(email, password);
      resolve(user);
    } catch (e) {
      reject(e);
    }
  });
};

export const completeNewPassword = (user, password) => {
  return new Promise(async (resolve, reject) => {
    try {
      const email = user?.challengeParam?.userAttributes?.email;
      const loggedUser = await Auth.completeNewPassword(user, password, {
        email,
      });
      resolve(loggedUser);
    } catch (e) {
      reject(e.message);
    }
  });
};

export const forgotPassword = (username) => {
  return new Promise(async (resolve, reject) => {
    try {
      const user = await Auth.forgotPassword(username);
      resolve(user);
    } catch (e) {
      reject(e);
    }
  });
};

export const forgotPasswordSubmit = (username, code, new_password) => {
  return new Promise(async (resolve, reject) => {
    try {
      const user = await Auth.forgotPasswordSubmit(
        username,
        code,
        new_password
      );
      resolve(user);
    } catch (e) {
      reject(e);
    }
  });
};
